import { useJumboLayoutSidebar } from '@jumbo/hooks';
import HistoryIcon from '@mui/icons-material/History';
import ReviewsIcon from '@mui/icons-material/Reviews';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import VideocamIcon from '@mui/icons-material/Videocam';
import { Box, Card, Chip, Tooltip, Typography } from '@mui/material';
import { getLocaleDateWithTimeCustom } from 'app/utils/appHelpers';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentMeeting } from 'stores/meeting';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import AvatarListGroup from '../AvatarListGroup';


function DashboardPreviousCard({ meeting, type }) {

    const userList = useSelector(state => state.user.data || []);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    let users = meeting.users
    let mUsers = []
    if (users !== null && users.length > 0) {
        users.forEach(element => {
            const user = userList.find(item => item.id === element);
            mUsers.push(user)
        });
    }


    const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();

    const handleCardClick = () => {
        const updatedMeeting = {
            ...meeting,
            users: mUsers,
        };
        dispatch(setCurrentMeeting(updatedMeeting));

        navigate('/previousPage');
        setSidebarOptions({ open: false })
    };
    const { itemSize, iconFontSize, baseFontSize, dshPreviousBackgroundcolor, dshReviewBackgroundcolor, dshVoteBackgroundcolor, dshVideoBackgroundcolor, dshPreviousChip, dshReviewChip, dshVoteChip, dshVideoChip } = useTemplateFontSettings();

    return (



        <Card
            sx={type === "uye" ? {
                backgroundColor: dshPreviousBackgroundcolor,
                minHeight: '140px',
                maxHeight: '150px',
                fontSize: baseFontSize,
                padding: '7px',
            } : {
                elevation: 0,
                boxShadow: 'none',
                backgroundColor: (() => {
                    if (meeting.statFinish === 1) return dshPreviousBackgroundcolor;
                    if (meeting.statReview === 1 && meeting.statVote === 0 && meeting.statVideoCall === 0) return dshReviewBackgroundcolor;
                    if (meeting.statVote === 1 && meeting.statReview === 0 && meeting.statVideoCall === 0) return dshVoteBackgroundcolor;
                    if (meeting.statVideoCall === 1 && meeting.statReview === 0 && meeting.statVote === 0) return dshVideoBackgroundcolor;
                    return dshPreviousBackgroundcolor;
                })(),
                minHeight: '130px',
                maxHeight: '140px',
                margin: '4px',
                width: '150px',
                height: '150px',
                fontSize: itemSize,
                padding: '7px',
                opacity: meeting.decisionCount > 0 ? 1 : 0.6,
                cursor: meeting.decisionCount > 0 ? 'pointer' : 'default'
            }}
            onClick={meeting.decisionCount > 0 ? () => handleCardClick() : undefined}
        >
            <Tooltip
                title={meeting.decisionCount !== 0 ? "Toplantıyı izlemek için dokunun lütfen" : "Gündem olmadığı için giriş yapılamaz"}
                arrow
                style={{ color: "#424242", cursor: 'pointer', fontSize: itemSize }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', p: 0, m: 0 }}>
                    {/* Header: Icon ve Chip */}
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            p: 0,
                            marginBottom: '5px'
                        }}
                    >
                        {(() => {
                            if (meeting.statFinish === 1) {
                                return <HistoryIcon style={{ color: "#F57C00", fontSize: iconFontSize }} />;
                            }
                            if (meeting.statReview === 1 && meeting.statVote === 0 && meeting.statVideoCall === 0) {
                                return <ReviewsIcon style={{ color: "#3F88C5", fontSize: iconFontSize }} />;
                            }
                            if (meeting.statVote === 1 && meeting.statReview === 0 && meeting.statVideoCall === 0) {
                                return <ThumbsUpDownIcon style={{ color: "#5A8F57", fontSize: iconFontSize }} />;
                            }
                            if (meeting.statVideoCall === 1 && meeting.statReview === 0 && meeting.statVote === 0) {
                                return <VideocamIcon style={{ color: "#c2185b", fontSize: iconFontSize }} />;
                            }
                            return <HistoryIcon style={{ color: "#F57C00", fontSize: iconFontSize }} />;
                        })()}
                        <Chip
                            size="small"
                            label={`${meeting.decisionCount} Madde`}
                            sx={{
                                bgcolor: (() => {
                                    if (meeting.statFinish === 1) return dshPreviousChip;
                                    if (meeting.statReview === 1 && meeting.statVote === 0 && meeting.statVideoCall === 0) return dshReviewChip;
                                    if (meeting.statVote === 1 && meeting.statReview === 0 && meeting.statVideoCall === 0) return dshVoteChip;
                                    if (meeting.statVideoCall === 1 && meeting.statReview === 0 && meeting.statVote === 0) return dshVideoChip;
                                    return dshPreviousChip;
                                })(),
                                fontSize: itemSize,
                                padding: '0',
                                color: '#ffffff'
                            }}
                        />
                    </Box>
                    {/* İçerik Bölümü */}
                    <Box sx={{ mt: 1, p: 0, m: 0 }}>
                        {/* Sabit yüksekliğe sahip kapsayıcı: unit metni için */}
                        <Box
                            sx={{
                                height: '40px',
                                overflow: 'hidden',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    fontSize: meeting.unit.length > 50 ? '8px' : itemSize,
                                    color: '#424242'
                                }}
                            >
                                {meeting.inst} {meeting.unit}
                            </Typography>
                        </Box>
                        <hr style={{ margin: '2px 0' }} />
                        <Typography
                            sx={{ textAlign: 'left', fontSize: itemSize, color: '#424242' }}
                        >
                            Sayı: {meeting.meetingNo}
                        </Typography>
                        <Typography
                            sx={{ textAlign: 'left', fontSize: itemSize, color: '#424242' }}
                        >
                            Tarih: {getLocaleDateWithTimeCustom('tr', meeting.pdate)}
                        </Typography>
                        <Box sx={{ textAlign: 'left', p: 0, m: 0 }}>
                            <AvatarListGroup users={mUsers} avatarSize={"22px"} />
                        </Box>
                    </Box>
                </Box>
            </Tooltip>
        </Card>
    );

}

export default DashboardPreviousCard;